jQuery(document).ready(function($) {
    $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
            action: 'load_rss_feed',
        },
        success: function(response) {
            if (response.success) {
                var items = response.data;
                var container = $('.rss-feed-container');

                items.forEach(function(item) {
                    var rssItemHtml = `
                        <a href="${item.link}" target="_blank" class="block relative min-h-[260px] min-w-[260px] xl:h-[340px] 2xl:h-[430px] rounded-lg overflow-hidden shadow-lg transition transform xl:hover:scale-105 duration-300 ease-in-out">
                            <img src="${item.image_url}" alt="Jakt & Jägare artikel" class="object-cover w-full h-full">
                            <div class="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-90 rounded-lg"></div>
                            <div class="absolute bottom-0 w-full text-white text-lg p-6 2xl:p-10">
                                <div class="font-myriad text-sm tracking-wider">${item.date}</div>
                                <h3 class="font-bold text-lg">${item.title}</h3>
                            </div>
                        </a>
                    `;
                    container.append(rssItemHtml);
                });
            }
        },
    });
});

//# sourceMappingURL=rss-load.js.map
